import { AppDispatch } from "../store";

import { receiveAcl } from "./reducer";
import {
  getAclUsingGlobalLevelToken,
  getAclUsingSiteLevelToken,
} from "../redux/accessTokenManagerActions";

export const ensureAcl = (customerId: string, siteId: string) => async (
  dispatch: AppDispatch,
): Promise<void> => {
  const acl = await dispatch(getAclUsingSiteLevelToken(customerId, siteId));
  await dispatch(receiveAcl(acl));
};

export const ensureAclGlobalLevel = () => async (
  dispatch: AppDispatch,
): Promise<void> => {
  const acl = await dispatch(getAclUsingGlobalLevelToken());
  await dispatch(receiveAcl(acl));
};
